import React from 'react';

const Tick = function Tick() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="checked-sign" version="1.1" id="Capa_1" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 448.8 448.8" xmlSpace="preserve">
      <g>
        <g id="check">
          <polygon points="142.8,323.85 35.7,216.75 0,252.45 142.8,395.25 448.8,89.25 413.1,53.55   " fill="#27CE0A" />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
};

export default Tick;
